import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { AGENT_FILTER_INCLUSION_DEFAULTS, COMMON_AGENT_FILTER_QUERY_PARAMS } from "../../agent/api";
import { CommissionsBatchType } from "../batch/enums";
import { PointsReportType } from "./enums";
import { PointsReportFilterExportRequest, PointsReportFilterPageRequest, PointsReportFilterPageResult } from "./types";

const FILTER_POINTS_REPORT = ApiRequestAdapter.create("/points-report", HttpMethod.POST);
const DOWNLOAD_POINTS_REPORT_EXPORT = ApiRequestAdapter.create("/points-report/export", HttpMethod.POST);

export const pointsReportApi = {
  filterPointsReport: (request: PointsReportFilterPageRequest): AxiosPromise<PointsReportFilterPageResult> => {
    return apiService.post(FILTER_POINTS_REPORT.url, request);
  },
  downloadPointsReportExport: (request: PointsReportFilterExportRequest): AxiosPromise<Blob> => {
    return apiService.post(DOWNLOAD_POINTS_REPORT_EXPORT.url, request, {
      responseType: "blob",
    });
  },
};

export const DEFAULT_POINTS_QUERY_PARAMS: Omit<Required<PointsReportFilterPageRequest>, "orderByPeriodIndex"> = {
  ...COMMON_AGENT_FILTER_QUERY_PARAMS,
  ...AGENT_FILTER_INCLUSION_DEFAULTS.NONE_INCLUDED,
  orderBy: [],
  orderDirections: [],
  periodStartDate: "",
  periodEndDate: "",
  institutionIds: [],
  productIds: [],
  commissionBatchIds: [],
  reportType: PointsReportType.NETTO_POINTS,
  commissionBatchType: "" as CommissionsBatchType,
};
